import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect } from "vue"
import _imports_0 from '@/assets/images/admin-img/image-icon.svg'
import _imports_1 from '@/assets/images/admin-img/light_delete-outline.svg'


const _hoisted_1 = { id: "mainContainer" }
const _hoisted_2 = { class: "admin-mid-container" }
const _hoisted_3 = {
  class: "admin-custom-row admin-page-row",
  id: "leftMenuSlideBox"
}
const _hoisted_4 = { class: "admin-right-sidebar" }
const _hoisted_5 = { class: "admin-right-sidebar-in" }
const _hoisted_6 = { class: "admin-right-sidebar-in-top" }
const _hoisted_7 = { class: "admin-custom-row" }
const _hoisted_8 = { class: "admin-right-sidebar-in-top-left" }
const _hoisted_9 = { class: "admin-page-type-links" }
const _hoisted_10 = { class: "admin-right-sidebar-in-top-right" }
const _hoisted_11 = { class: "admin-right-sidebar-in-top-right-top" }
const _hoisted_12 = { class: "admin-search-box" }
const _hoisted_13 = { class: "admin-add-btn" }
const _hoisted_14 = {
  key: 0,
  class: "admin-right-sidebar-in-top-right-btm"
}
const _hoisted_15 = { class: "tags" }
const _hoisted_16 = { class: "delete-all-btn-link" }
const _hoisted_17 = {
  key: 0,
  class: "white-bg-border add-new-section"
}
const _hoisted_18 = { class: "add-banner-image-section" }
const _hoisted_19 = { class: "add-banner-image-box" }
const _hoisted_20 = { class: "admin-input-field" }
const _hoisted_21 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_22 = { class: "admin-input-field" }
const _hoisted_23 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_24 = { class: "admin-input-field" }
const _hoisted_25 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_26 = { class: "admin-input-field" }
const _hoisted_27 = { class: "image-upload-input upload-banner-image" }
const _hoisted_28 = { class: "file-input-box" }
const _hoisted_29 = {
  key: 0,
  class: "image-upload-input-item-in"
}
const _hoisted_30 = {
  key: 1,
  class: "image-upload-input-item-uploaded"
}
const _hoisted_31 = ["src"]
const _hoisted_32 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_33 = { class: "admin-input-field-submit" }
const _hoisted_34 = ["disabled"]
const _hoisted_35 = {
  class: "admin-item-list-section-in",
  ref: "scrollWrapper",
  "data-simplebar": ""
}
const _hoisted_36 = { class: "admin-item-list-section-scroll" }
const _hoisted_37 = { class: "admin-item-list-top" }
const _hoisted_38 = { class: "admin-item-list-row" }
const _hoisted_39 = { class: "admin-item-checkbox" }
const _hoisted_40 = { class: "admin-checkbox-input" }
const _hoisted_41 = ["checked"]
const _hoisted_42 = { class: "admin-item-image" }
const _hoisted_43 = { class: "admin-item-actions" }
const _hoisted_44 = { class: "admin-item-list-btm" }
const _hoisted_45 = { ref: "sortableList" }
const _hoisted_46 = { class: "admin-item-box-top" }
const _hoisted_47 = { class: "admin-item-list-row" }
const _hoisted_48 = { class: "admin-item-checkbox" }
const _hoisted_49 = { class: "admin-checkbox-input" }
const _hoisted_50 = ["id", "onChange", "checked"]
const _hoisted_51 = ["for"]
const _hoisted_52 = { class: "admin-item-image" }
const _hoisted_53 = { class: "sm-img" }
const _hoisted_54 = ["src"]
const _hoisted_55 = { class: "admin-item-sm-title text-limit" }
const _hoisted_56 = { class: "admin-item-industry-sort-desc text-limit" }
const _hoisted_57 = { class: "admin-item-industry-desc text-limit" }
const _hoisted_58 = { class: "admin-item-actions" }
const _hoisted_59 = { class: "admin-action-link" }
const _hoisted_60 = ["onClick"]
const _hoisted_61 = ["onClick"]
const _hoisted_62 = ["onClick"]
const _hoisted_63 = ["onClick"]
const _hoisted_64 = {
  key: 0,
  class: "admin-item-box-btm"
}
const _hoisted_65 = { class: "add-banner-image-section" }
const _hoisted_66 = { class: "add-banner-image-box" }
const _hoisted_67 = { class: "admin-input-field" }
const _hoisted_68 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_69 = { class: "admin-input-field" }
const _hoisted_70 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_71 = { class: "admin-input-field" }
const _hoisted_72 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_73 = { class: "admin-input-field" }
const _hoisted_74 = { class: "image-upload-input upload-banner-image" }
const _hoisted_75 = { class: "image-upload-input-item uploaded-done" }
const _hoisted_76 = { class: "file-input-box" }
const _hoisted_77 = { class: "image-upload-input-item-uploaded" }
const _hoisted_78 = ["src"]
const _hoisted_79 = {
  key: 0,
  class: "error-msg"
}
const _hoisted_80 = { class: "admin-input-field-submit" }
const _hoisted_81 = ["onClick"]
const _hoisted_82 = { class: "admin-pagination-section" }
const _hoisted_83 = { class: "custom-row" }
const _hoisted_84 = { class: "item-show-selectbox" }
const _hoisted_85 = {
  key: 0,
  class: "admin-pagination",
  id: "paginationBox"
}
const _hoisted_86 = ["onClick"]
const _hoisted_87 = { key: 2 }
const _hoisted_88 = { class: "admin-site-footer" }
const _hoisted_89 = { class: "container" }
const _hoisted_90 = {
  class: "modal fade confirmation-popup",
  id: "deletePop",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "deleteModalLabel",
  "aria-hidden": "true",
  "data-bs-backdrop": "static"
}
const _hoisted_91 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_92 = { class: "modal-content" }
const _hoisted_93 = { class: "confirmation-popup-mid" }
const _hoisted_94 = { class: "confirmation-popup-btm" }
const _hoisted_95 = {
  id: "popNoBtn",
  class: "admin-btn-outline-secondary",
  "data-bs-dismiss": "modal"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_adminHeader = _resolveComponent("adminHeader")!
  const _component_adminNavigation = _resolveComponent("adminNavigation")!
  const _component_ckeditor = _resolveComponent("ckeditor")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_adminHeader),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_adminNavigation),
        _createElementVNode("section", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("h1", null, _toDisplayString(_ctx.constants.MANAGE_INDUSTRY_TEXT), 1),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          id: "allLink",
                          href: "#",
                          class: _normalizeClass({ active: _ctx.activeTab === 'all' }),
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.switchView('all')))
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.constants.ALL_LINK) + " ", 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.counts.all), 1)
                        ], 2)
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          id: "publishedhLink",
                          href: "#",
                          class: _normalizeClass({ active: _ctx.activeTab === 'published' }),
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.switchView('published')))
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.constants.PUBLISHED_LINK) + " ", 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.counts.published), 1)
                        ], 2)
                      ]),
                      _createElementVNode("li", null, [
                        _createElementVNode("a", {
                          id: "unPublishedhLink",
                          href: "#",
                          class: _normalizeClass({ active: _ctx.activeTab === 'unpublished' }),
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.switchView('unpublished')))
                        }, [
                          _createTextVNode(_toDisplayString(_ctx.constants.UNPUBLISHED_LINK) + " ", 1),
                          _createElementVNode("span", null, _toDisplayString(_ctx.counts.unpublished), 1)
                        ], 2)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _withDirectives(_createElementVNode("input", {
                        id: "adminSearchInput",
                        type: "text",
                        placeholder: "Search",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchedText) = $event)),
                        onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.fetchIndustries(_ctx.activeTab), _ctx.fetchCounts(_ctx.searchedText)), ["enter"]))
                      }, null, 544), [
                        [_vModelText, _ctx.searchedText]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("button", {
                        id: "addIndustryButton",
                        class: _normalizeClass(["add-btn-admin", { 'active': _ctx.showAddForm }]),
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showAddForm = true, _ctx.selectedIndustries = [], _ctx.selectAll = false, _ctx.cancelEdit()))
                      }, [
                        _cache[30] || (_cache[30] = _createElementVNode("i", { class: "add-icon" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.constants.ADD_INDUSTRY_BUTTON), 1)
                      ], 2)
                    ])
                  ]),
                  (_ctx.selectedIndustries.length > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("ul", null, [
                            _createElementVNode("li", null, [
                              _createElementVNode("span", null, _toDisplayString(_ctx.selectedIndustries.length) + " entries selected", 1),
                              _createElementVNode("button", {
                                id: "tagCloseBtn",
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectedIndustries = [], _ctx.selectAll = false))
                              })
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("button", {
                            class: "btn_link",
                            id: "deleteAllBtn",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#deletePop",
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setDeleteMode('all')))
                          }, _toDisplayString(_ctx.constants.DELETE_ALL_BUTTON), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            (_ctx.showAddForm)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("h2", null, _toDisplayString(_ctx.constants.ADD_NEW_INDUSTRY_TEXT), 1),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("form", {
                        id: "addIndustryForm",
                        onSubmit: _cache[14] || (_cache[14] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
                      }, [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.TITLE_LABEL), 1),
                          _withDirectives(_createElementVNode("input", {
                            id: "industryTitleInput",
                            type: "text",
                            placeholder: "Enter the Title",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.newIndustrie.title) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.newIndustrie.title]
                          ]),
                          (!_ctx.newIndustrie.title)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString(_ctx.errMsg), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.SUB_HEADING_LABEL), 1),
                          _createVNode(_component_ckeditor, {
                            placeholder: "Short Description",
                            class: "text-editer",
                            id: "industrySubHeadingInput",
                            editor: _ctx.editor,
                            modelValue: _ctx.newIndustrie.shortDescription,
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.newIndustrie.shortDescription) = $event)),
                            config: _ctx.editorConfig
                          }, null, 8, ["editor", "modelValue", "config"]),
                          (!_ctx.newIndustrie.shortDescription)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_ctx.errMsg), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.DESCRIPTION_LABEL), 1),
                          _createVNode(_component_ckeditor, {
                            placeholder: "Description",
                            class: "text-editer",
                            id: "industryDescriptionInput",
                            editor: _ctx.editor,
                            modelValue: _ctx.newIndustrie.description,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.newIndustrie.description) = $event)),
                            config: _ctx.editorConfig
                          }, null, 8, ["editor", "modelValue", "config"]),
                          (!_ctx.newIndustrie.description)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_ctx.errMsg), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.INDUSTRY_IMAGE_LABEL), 1),
                          _createElementVNode("div", _hoisted_27, [
                            _createElementVNode("div", {
                              class: _normalizeClass(['image-upload-input-item', { 'uploaded-done': _ctx.imageUploaded }])
                            }, [
                              _createElementVNode("div", _hoisted_28, [
                                _createElementVNode("button", {
                                  class: "image-upload-input-item-delete-btn",
                                  id: "uploaded-img-delete-btn",
                                  type: "button",
                                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.clearUploadedImage(false)))
                                }),
                                _createElementVNode("input", {
                                  id: "addIndustryImageInput",
                                  onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.handleFileUpload($event, false))),
                                  accept: "image/jpeg,image/jpg,image/png",
                                  type: "file"
                                }, null, 32)
                              ]),
                              (!_ctx.imageUploaded)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                    _cache[31] || (_cache[31] = _createElementVNode("div", { class: "image-upload-input-item-icon" }, [
                                      _createElementVNode("img", {
                                        src: _imports_0,
                                        alt: ""
                                      })
                                    ], -1)),
                                    _createElementVNode("span", null, _toDisplayString(_ctx.constants.ADD_IMAGE_LABEL), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.imageUploaded)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                    _createElementVNode("img", {
                                      src: _ctx.imageUrl,
                                      alt: "",
                                      class: "mCS_img_loaded"
                                    }, null, 8, _hoisted_31)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 2)
                          ]),
                          (!_ctx.selectedFile)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(_ctx.errMsg), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_33, [
                          _createElementVNode("button", {
                            id: "industrySubmitBtn",
                            type: "submit",
                            class: "admin-btn-outline-primary add-new-cancel",
                            disabled: _ctx.isSubmitting
                          }, _toDisplayString(_ctx.constants.SUBMIT_BUTTON), 9, _hoisted_34),
                          _createElementVNode("button", {
                            id: "industryCancleBtn",
                            type: "button",
                            class: "admin-btn-outline-secondary add-new-cancel",
                            onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.resetForm && _ctx.resetForm(...args)))
                          }, _toDisplayString(_ctx.constants.CANCEL_BUTTON), 1)
                        ])
                      ], 32)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (_ctx.editIndustriesData.length > 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(['admin-item-list-section banner-image-section', { 'show-edit-item-outer': _ctx.editFormSubmitted }])
                }, [
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("div", _hoisted_40, [
                              _createElementVNode("input", {
                                name: "cssCheckbox",
                                id: "selectAll",
                                type: "checkbox",
                                class: "css-checkbox",
                                onChange: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.toggleSelectAll && _ctx.toggleSelectAll(...args))),
                                checked: _ctx.selectAll === true
                              }, null, 40, _hoisted_41),
                              _cache[32] || (_cache[32] = _createElementVNode("label", { for: "selectAll" }, null, -1))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.constants.IMAGE_LABEL), 1),
                          _createElementVNode("div", {
                            class: "admin-item-sm-title",
                            onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.toggleSort('title'))),
                            style: {"cursor":"pointer"}
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.constants.TITLE_LABEL) + " ", 1),
                            (_ctx.sortBy === 'title' || _ctx.sortBy === '-title')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: _normalizeClass(["sorting-btn", { 'sorted': _ctx.sortBy === '-title' }])
                                }, null, 2))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", {
                            class: "admin-item-industry-sort-desc",
                            onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.toggleSort('shortDescription'))),
                            style: {"cursor":"pointer"}
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.constants.SUB_HEADING_LABEL) + " ", 1),
                            (_ctx.sortBy === 'shortDescription' || _ctx.sortBy === '-shortDescription')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: _normalizeClass(["sorting-btn", { 'sorted': _ctx.sortBy === '-shortDescription' }])
                                }, null, 2))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", {
                            class: "admin-item-industry-desc",
                            onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.toggleSort('description'))),
                            style: {"cursor":"pointer"}
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.constants.DESCRIPTION_LABEL) + " ", 1),
                            (_ctx.sortBy === 'description' || _ctx.sortBy === '-description')
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  class: _normalizeClass(["sorting-btn", { 'sorted': _ctx.sortBy === '-description' }])
                                }, null, 2))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.constants.ACTIONS_LABEL), 1),
                          _cache[33] || (_cache[33] = _createElementVNode("div", { class: "clear" }, null, -1))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("div", _hoisted_45, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.editIndustriesData, (industrie, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: industrie.id,
                              class: _normalizeClass(['admin-item-box', { 'show-edit-item': industrie.editing }])
                            }, [
                              _createElementVNode("div", _hoisted_46, [
                                _createElementVNode("div", _hoisted_47, [
                                  _createElementVNode("div", _hoisted_48, [
                                    _createElementVNode("div", _hoisted_49, [
                                      _createElementVNode("input", {
                                        name: "cssCheckbox",
                                        id: 'demo_opt_' + industrie.id,
                                        type: "checkbox",
                                        class: "css-checkbox",
                                        onChange: ($event: any) => (_ctx.toggleIndustrieSelection(industrie.id)),
                                        checked: _ctx.selectedIndustries.includes(industrie.id)
                                      }, null, 40, _hoisted_50),
                                      _createElementVNode("label", {
                                        for: 'demo_opt_' + industrie.id
                                      }, null, 8, _hoisted_51)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_52, [
                                    _createElementVNode("div", _hoisted_53, [
                                      _createElementVNode("img", {
                                        src: _ctx.getCdnImageAddress(industrie.industryImage, `w_40,h_41/`) || '@/assets/images/admin-img/demo-img/item-img-1.jpg',
                                        alt: ""
                                      }, null, 8, _hoisted_54)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_55, _toDisplayString(industrie.title), 1),
                                  _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.useStripHtml(industrie.shortDescription)), 1),
                                  _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.useStripHtml(industrie.description)), 1),
                                  _createElementVNode("div", _hoisted_58, [
                                    _createElementVNode("ul", _hoisted_59, [
                                      _createElementVNode("li", null, [
                                        _createElementVNode("button", {
                                          id: "industryPgEditBtn",
                                          class: "editBtn",
                                          onClick: ($event: any) => (_ctx.editIndustrie(index), _ctx.showAddForm = false)
                                        }, _toDisplayString(_ctx.constants.EDIT_BUTTON), 9, _hoisted_60)
                                      ]),
                                      _createElementVNode("li", null, [
                                        _createElementVNode("button", {
                                          id: "industryPgDeleteBtn",
                                          "data-bs-toggle": "modal",
                                          "data-bs-target": "#deletePop",
                                          onClick: ($event: any) => (_ctx.setDeleteMode('single', industrie.id), _ctx.showAddForm = false, _ctx.cancelEdit())
                                        }, _toDisplayString(_ctx.constants.DELETE_BUTTON), 9, _hoisted_61)
                                      ]),
                                      _createElementVNode("li", null, [
                                        (industrie.status === 1)
                                          ? (_openBlock(), _createElementBlock("button", {
                                              key: 0,
                                              id: "industryPgUnPublishBtn",
                                              class: "primary-outline-btn",
                                              onClick: ($event: any) => (_ctx.changeIndustrieStatus(industrie.id, 0))
                                            }, _toDisplayString(_ctx.constants.UNPUBLISH_BUTTON), 9, _hoisted_62))
                                          : (industrie.status === 0)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 1,
                                                id: "industryPgPublishBtn",
                                                class: "primary-outline-btn",
                                                onClick: ($event: any) => (_ctx.changeIndustrieStatus(industrie.id, 1))
                                              }, _toDisplayString(_ctx.constants.PUBLISH_BUTTON), 9, _hoisted_63))
                                            : _createCommentVNode("", true)
                                      ])
                                    ])
                                  ]),
                                  _cache[34] || (_cache[34] = _createElementVNode("div", { class: "clear" }, null, -1))
                                ])
                              ]),
                              (industrie.editing)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                    _createElementVNode("div", _hoisted_65, [
                                      _createElementVNode("h2", null, _toDisplayString(_ctx.constants.EDIT_INDUSTRY_TEXT), 1),
                                      _createElementVNode("div", _hoisted_66, [
                                        _createElementVNode("div", _hoisted_67, [
                                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.TITLE_LABEL), 1),
                                          _withDirectives(_createElementVNode("input", {
                                            id: "industryTitleInput",
                                            type: "text",
                                            placeholder: "Enter the Title",
                                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.editIndustrieData.title) = $event))
                                          }, null, 512), [
                                            [_vModelText, _ctx.editIndustrieData.title]
                                          ]),
                                          (!_ctx.editIndustrieData.title)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_68, _toDisplayString(_ctx.errEditMsg), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_69, [
                                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.SUB_HEADING_LABEL), 1),
                                          _createVNode(_component_ckeditor, {
                                            placeholder: "Short Description",
                                            id: "industrySubHeadingInput",
                                            class: "text-editer",
                                            editor: _ctx.editor,
                                            modelValue: _ctx.editIndustrieData.shortDescription,
                                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.editIndustrieData.shortDescription) = $event)),
                                            config: _ctx.editorConfig
                                          }, null, 8, ["editor", "modelValue", "config"]),
                                          (!_ctx.editIndustrieData.shortDescription)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_70, _toDisplayString(_ctx.errEditMsg), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_71, [
                                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.DESCRIPTION_LABEL), 1),
                                          _createVNode(_component_ckeditor, {
                                            placeholder: "Description",
                                            id: "industryDescriptionInput",
                                            class: "text-editer",
                                            editor: _ctx.editor,
                                            modelValue: _ctx.editIndustrieData.description,
                                            "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.editIndustrieData.description) = $event)),
                                            config: _ctx.editorConfig
                                          }, null, 8, ["editor", "modelValue", "config"]),
                                          (!_ctx.editIndustrieData.description)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_72, _toDisplayString(_ctx.errEditMsg), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_73, [
                                          _createElementVNode("label", null, _toDisplayString(_ctx.constants.INDUSTRY_IMAGE_LABEL), 1),
                                          _createElementVNode("div", _hoisted_74, [
                                            _createElementVNode("div", _hoisted_75, [
                                              _createElementVNode("div", _hoisted_76, [
                                                _createElementVNode("button", {
                                                  class: "image-upload-input-item-delete-btn",
                                                  id: "uploaded-img-delete-btn",
                                                  type: "button",
                                                  onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.clearUploadedImage(true)))
                                                }),
                                                _createElementVNode("input", {
                                                  id: "editIndustryImageInput",
                                                  type: "file",
                                                  onChange: _cache[23] || (_cache[23] = ($event: any) => (_ctx.handleFileUpload($event, true))),
                                                  accept: "image/jpeg,image/jpg,image/png"
                                                }, null, 32)
                                              ]),
                                              _createElementVNode("div", _hoisted_77, [
                                                _createElementVNode("img", {
                                                  src: _ctx.editimageSrc || require('@/assets/images/admin-img/image-icon.svg'),
                                                  alt: ""
                                                }, null, 8, _hoisted_78)
                                              ])
                                            ])
                                          ]),
                                          (!_ctx.editimageSrc && !_ctx.selectedEditFile)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_79, _toDisplayString(_ctx.errEditMsg), 1))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _createElementVNode("div", _hoisted_80, [
                                          _createElementVNode("button", {
                                            id: "industrySubmitBtn",
                                            class: "admin-btn-outline-primary",
                                            onClick: ($event: any) => (_ctx.submitEditForm(industrie.id))
                                          }, _toDisplayString(_ctx.constants.SUBMIT_BUTTON), 9, _hoisted_81),
                                          _createElementVNode("button", {
                                            id: "industryCancleBtn",
                                            class: "admin-btn-outline-secondary addNewCancel",
                                            onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.cancelEdit && _ctx.cancelEdit(...args)))
                                          }, _toDisplayString(_ctx.constants.CANCEL_BUTTON), 1)
                                        ])
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ], 2))
                          }), 128))
                        ], 512)
                      ])
                    ])
                  ], 512),
                  _createElementVNode("div", _hoisted_82, [
                    _createElementVNode("div", _hoisted_83, [
                      _createElementVNode("div", _hoisted_84, [
                        _withDirectives(_createElementVNode("select", {
                          id: "paginationSelectBox",
                          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.limit) = $event)),
                          onChange: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.handleLimitChange && _ctx.handleLimitChange(...args)))
                        }, [...(_cache[35] || (_cache[35] = [
                          _createElementVNode("option", { value: "10" }, "10", -1),
                          _createElementVNode("option", { value: "20" }, "20", -1),
                          _createElementVNode("option", { value: "50" }, "50", -1),
                          _createElementVNode("option", { value: "100" }, "100", -1)
                        ]))], 544), [
                          [_vModelSelect, _ctx.limit]
                        ]),
                        _createElementVNode("span", null, _toDisplayString(_ctx.constants.ENTRIES_PER_PAGE_LABEL), 1)
                      ]),
                      (_ctx.totalPages > 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                            _createElementVNode("ul", null, [
                              (_ctx.currentPage !== 1)
                                ? (_openBlock(), _createElementBlock("li", {
                                    key: 0,
                                    onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.changePage(_ctx.currentPage - 1)))
                                  }, [...(_cache[36] || (_cache[36] = [
                                    _createElementVNode("a", {
                                      href: "#",
                                      class: "pagination-previous"
                                    }, null, -1)
                                  ]))]))
                                : _createCommentVNode("", true),
                              (_ctx.totalPages != 1)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.visiblePages, (page) => {
                                    return (_openBlock(), _createElementBlock("li", {
                                      key: page,
                                      onClick: ($event: any) => (_ctx.changePage(page))
                                    }, [
                                      _createElementVNode("a", {
                                        href: "#",
                                        class: _normalizeClass({ active: _ctx.currentPage === page })
                                      }, _toDisplayString(page), 3)
                                    ], 8, _hoisted_86))
                                  }), 128))
                                : _createCommentVNode("", true),
                              (_ctx.currentPage !== _ctx.totalPages)
                                ? (_openBlock(), _createElementBlock("li", {
                                    key: 2,
                                    onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.changePage(_ctx.currentPage + 1)))
                                  }, [...(_cache[37] || (_cache[37] = [
                                    _createElementVNode("a", {
                                      href: "#",
                                      class: "pagination-next"
                                    }, null, -1)
                                  ]))]))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ], 2))
              : (_openBlock(), _createElementBlock("div", _hoisted_87, [...(_cache[38] || (_cache[38] = [
                  _createElementVNode("p", null, "No data to display", -1)
                ]))]))
          ])
        ])
      ])
    ]),
    _createElementVNode("footer", _hoisted_88, [
      _createElementVNode("div", _hoisted_89, _toDisplayString(_ctx.constants.COPYRIGHT_TEXT), 1)
    ]),
    _createElementVNode("div", _hoisted_90, [
      _createElementVNode("div", _hoisted_91, [
        _createElementVNode("div", _hoisted_92, [
          _cache[39] || (_cache[39] = _createElementVNode("div", { class: "confirmation-popup-icon" }, [
            _createElementVNode("i", null, [
              _createElementVNode("img", {
                src: _imports_1,
                alt: ""
              })
            ])
          ], -1)),
          _createElementVNode("div", _hoisted_93, [
            _createElementVNode("p", null, _toDisplayString(_ctx.constants.ARE_YOU_SURE_YOU_WANT_TO_DELETE_THIS_TEXT), 1)
          ]),
          _createElementVNode("div", _hoisted_94, [
            _createElementVNode("button", _hoisted_95, _toDisplayString(_ctx.constants.NO_BUTTON), 1),
            _createElementVNode("button", {
              id: "popYesBtn",
              class: "admin-btn-outline-primary",
              "data-bs-dismiss": "modal",
              onClick: _cache[29] || (_cache[29] = 
//@ts-ignore
(...args) => (_ctx.confirmDelete && _ctx.confirmDelete(...args)))
            }, _toDisplayString(_ctx.constants.YES_BUTTON), 1)
          ])
        ])
      ])
    ])
  ]))
}